import script from "./global.vue?vue&type=script&setup=true&lang=js"
export * from "./global.vue?vue&type=script&setup=true&lang=js"

import "./global.vue?vue&type=style&index=0&id=1f17b310&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f17b310"]])

export default __exports__